import { BehaviorSubject } from 'rxjs';

/**
 * Whether this window follows a crewmate's work (the follow of the assistant,
 * like following a moderator). Only a following window lets a playback bring
 * its target into view (page a calendar, scroll a table); any other window
 * keeps the user's own view. The workspace sets it, the views read it.
 */
export const agentFollowing$ = new BehaviorSubject<boolean>(false);

/** A database block that can bring one of its rows into view in the view it shows. */
export interface AgentRowRevealer {
  revealAgentRow(rowId: string): boolean;
}

export function isAgentRowRevealer(
  element: unknown
): element is AgentRowRevealer {
  return (
    !!element &&
    typeof (element as Partial<AgentRowRevealer>).revealAgentRow === 'function'
  );
}
